{
  "promotion": {
    "bookingConfirmation": {
      "title": "Matka varattu. Kiitos!",
      "content": "<p>Olemme lähettäneet erikseen varaustiedot ja e-liput osoitteeseen: <b>{email}</b>.</p><p>Etkö ole saanut niitä 24 tunnin kuluessa? Ota yhteyttä asiakaspalveluun.</p><p>Voit nyt tarkastella ja muokata matkaasi sekä löytää matkaasi sopivan hotellin tai vuokrata auton tällä sivulla.</p>",
      "buttonText": "Miten varaus sujui?"
    }
  },
  "subHeader": {
    "backToMyBookings": "Poistu sivulta",
    "backToMyBookingsAria": "Poistu sivulta"
  },
  "includedProducts": {
    "seatWifi": {
      "text": "{displayName}"
    },
    "seatFreshMeal": {
      "text": "{displayName}"
    },
    "seatHotPreOrderMeal": {
      "text": "{displayName}"
    },
    "seatCabinBaggage": {
      "title": "Lounge + Käsimatkatavara -kombo",
      "text": "{displayName}"
    },
    "seatPriorityServices": {
      "text": "{displayName}"
    },
    "loungePriority": {
      "title": "Lounge + Priority -kombo"
    },
    "loungePriorityServices": {
      "text": "{displayName}"
    },
    "loungeCabinBaggage": {
      "text": "{displayName}"
    },
    "loungeWifi": {
      "title": "Lounge + Internet -kombo",
      "text": "{displayName}"
    },
    "wifiMeal": {
      "title": "Internet + Ateria -kombo"
    },
    "wifiFreshMeal": {
      "text": "{displayName}"
    },
    "wifiHotPreOrderMeal": {
      "text": "{displayName}"
    }
  },
  "services": {
    "seatWifi": {
      "paid": "{amount} x Istuinpaikka + Internet"
    },
    "seatMeal": {
      "paid": "{amount} x Istuinpaikka + Ateria"
    },
    "seatPriority": {
      "paid": "{amount} x Istuinpaikka + Priority"
    },
    "seatCabinBaggage": {
      "paid": "{amount} x Istuinpaikka + Käsimatkatavara"
    },
    "loungePriority": {
      "paid": "{amount} x Lounge + Priority"
    },
    "loungeWifi": {
      "paid": "{amount} x Lounge + Internet"
    },
    "loungeCabinBaggage": {
      "paid": "{amount} x Lounge + Käsimatkatavara"
    },
    "wifiMeal": {
      "paid": "{amount} x Internet + Ateria"
    }
  },
  "voluntaryChange": {
    "phases": {
      "checkPrices": {
        "loaderText": "Pieni hetki, haemme sinulle sopivia vaihtoehtoja",
        "disclaimer": {
          "title": "Hinnat perustuvat lipunhintojen erotukseen.",
          "description": "Näin voi tapahtua, jos alkuperäisen varausluokkasi paikkoja ei ole saatavilla, reitti muuttuu tai lipun hintaehdot eivät enää täyty."
        },
        "flexTicketDisclaimer": {
          "title": "Koska sinulla on Flex-lippu, ",
          "description": "hyvitämme hinnan erotuksen, jos uuden lentosi hinta on alkuperäistä edullisempi."
        },
        "selectNewDates": {
          "plural": "Valitse uudet matkustuspäivät",
          "singular": "Valitse uusi matkustuspäivä"
        }
      }
    },
    "ticketSelection": {
      "keepOriginalFlight": "Pidä alkuperäinen lentosi",
      "noChanges": "Ei muutoksia",
      "priceDisclaimer": "Hinnat määräytyvät saatavuuden mukaan, ja asiakaspalvelumme voi tarjota ainoastaan täällä näkyvät hinnat.",
      "flightsNotChangedModal": {
        "title": "Lennoissasi ei ole muutoksia",
        "returnToFlightSelect": "Palaa lennon valintaan",
        "returnToBooking": "Jatka Varaukseni-palveluun"
      }
    },
    "changeFlightsModal": {
      "title": "Muuta lentojasi"
    }
  }
}
